export default "__VITE_ASSET__47cac25b__"